import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const MessagesIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-messages${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M14 9.33333L12 7.33333H7.33335C7.15654 7.33333 6.98697 7.2631 6.86195 7.13807C6.73693 7.01305 6.66669 6.84348 6.66669 6.66667V2.66667C6.66669 2.48986 6.73693 2.32029 6.86195 2.19526C6.98697 2.07024 7.15654 2 7.33335 2H13.3334C13.5102 2 13.6797 2.07024 13.8048 2.19526C13.9298 2.32029 14 2.48986 14 2.66667V9.33333Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33333 10V11.3333C9.33333 11.5101 9.2631 11.6797 9.13807 11.8047C9.01305 11.9298 8.84348 12 8.66667 12H4L2 14V7.33334C2 7.15653 2.07024 6.98696 2.19526 6.86193C2.32029 6.73691 2.48986 6.66667 2.66667 6.66667H4"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default MessagesIcon;
